export default "__VITE_ASSET__CQ15bi4x__"